export const MAX_AGGREGATED_DATA_POINTS = 4000;
export const MAX_RAW_HISTORICAL_DATA_POINTS = 20000;
export const MAX_AGGREGATED_REQUEST_ENTRIES = 16;
export const MAX_RAW_HISTORICAL_REQUEST_ENTRIES = 16;
export const MAX_RAW_LATEST_REQUEST_ENTRIES = 128;
